export default "__VITE_ASSET__B3nYb_YK__"